import './styles.styl'
import moment from 'moment-timezone'
import React from 'react'

export default class UIComponent extends React.Component {
  componentWillMount () {
    if (this.props.fetched === false && this.props.fetching === false) {
      this.props.loadCustomers()
    }
  }

  destroy (name, id) {
    if (!window.confirm(`Weet u zeker dat u klant "${name}" wilt verwijderen? Dit kan niet ongedaan worden gemaakt en alle gekoppelde data (projecten, gebruikers, etc) gaat verloren.`)) {
      return
    }

    console.warn(`@TODO: destroy customer ${id}`)
  }

  render () {
    const {
      fetched,
      fetching,
      list
    } = this.props

    let content = null

    if (fetched === false) {
      content = (
        <div className='alert alert-primary'>
          <strong>Geen data...</strong><br />
          <a onClick={() => this.props.loadCustomers()}>Klik hier</a> om het opnieuw te proberen.
        </div>
      )
    }

    if (fetching === true) {
      content = (
        <div className='alert alert-primary'>
          <strong>Momentje...</strong><br />
          We halen de klantdata op.
        </div>
      )
    }

    if (fetched === true) {
      const rows = list.map((customer, index) => {
        return (
          <tr key={index}>
            <td>{index + 1}</td>
            <td><code>{customer.id}</code></td>
            <td>{customer.name}</td>
            <td>{customer.contactName}</td>
            <td>{moment(customer.createdAt).tz('Europe/Amsterdam').format('DD-MM-YYYY')}</td>
            <td>
              <button type='button' className='btn btn-sm btn-danger btn-rounded' onClick={() => this.destroy(customer.name, customer.id)}><i className='fa fa-times' /> Verwijder</button>
            </td>
          </tr>
        )
      })
      content = (
        <div className='page-inner'>
          <table className='table' cellPadding='0' cellSpacing='0'>
            <thead>
              <tr>
                <th width={40}>#</th>
                <th width={220}>ID</th>
                <th>Naam</th>
                <th width={200}>Contactpersoon</th>
                <th width={150}>Aangemaakt</th>
                <th width={100}></th>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </table>
        </div>
      )
    }

    return (
      <div className='page'>
        <header className='header'>
          <div className='container-fluid'>
            <div className='row'>
              <div className='col-12 col-sm-6'>
                <h1>Klanten</h1>
              </div>
              <div className='col-12 col-sm-6 text-align-right'>
                <button type='button' className='btn btn-success btn-rounded btn-add'><i className='fa fa-plus' /> Nieuwe klant</button>
              </div>
            </div>
          </div>
        </header>

        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12'>
              {content}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./ui/customers/component.js